import styled from 'styled-components';
import { VFC } from 'react';
import { Image, Button as AntdButton, Row, Col } from 'antd';
import { theme } from 'consts/theme';
import { getInstallationTechnologyButtonConfig } from 'routes/installation/const/config/installationTechnology';
import { useIntl } from 'react-intl';
import { InstallationTechnology } from '../../const/installationTechnology';

const StyledButton = styled(AntdButton)`
  width: 100%;
  height: 130px;
  background-color: ${theme.colors.lightGray};
  border: 2px solid ${theme.colors.dark};
  border-radius: 4px;
`;
const StyledText = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

interface InstallationTechnologyButtonProps {
  technology: InstallationTechnology;
  onClick: (technology: InstallationTechnology) => void;
}

export const InstallationTechnologyButton: VFC<InstallationTechnologyButtonProps> = ({ technology, onClick }) => {
  const intl = useIntl();
  const { image, name, imageWidth } = getInstallationTechnologyButtonConfig(intl, technology);

  return (
    <StyledButton value={technology} onClick={() => onClick(technology)}>
      <Row align="middle">
        <Col span={15} style={{ display: 'flex' }}>
          <Image alt={name} preview={false} src={image} width={imageWidth} />
        </Col>
        <Col span={9} style={{ display: 'flex' }}>
          <StyledText>{name}</StyledText>
        </Col>
      </Row>
    </StyledButton>
  );
};
